export enum StampCardSorter {
    IssuedAtDesc = 'IssuedAtDesc',
    ShopNameAsc = 'ShopNameAsc'
}

export type StampEventType =
    'ISSUED'
    | 'USED'
    | 'CANCELED'
    | 'EXPIRED'
    | 'RESET';
